import { cn } from "@/lib/cn";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface FormSkeletonProps {
  campos?: number;
  columnas?: 1 | 2 | 3 | 4;
  /** Fila de botones al pie (guardar/cancelar). */
  conAcciones?: boolean;
  className?: string;
  etiqueta?: string;
}

const GRID = { 1: "", 2: "md:grid-cols-2", 3: "sm:grid-cols-2 lg:grid-cols-3", 4: "md:grid-cols-4" } as const;

/** Formulario en carga · etiqueta + input por campo, en rejilla responsiva. */
export function FormSkeleton({ campos = 6, columnas = 2, conAcciones = false, className, etiqueta }: FormSkeletonProps) {
  return (
    <RegionCargando etiqueta={etiqueta} className={cn("flex flex-col gap-5", className)}>
      <div className={cn("grid grid-cols-1 gap-4", GRID[columnas])} aria-hidden="true">
        {Array.from({ length: campos }, (_, i) => (
          <div key={i} className="flex flex-col gap-1.5">
            <Skeleton height={12} width={i % 2 === 0 ? "35%" : "50%"} />
            <Skeleton height={36} />
          </div>
        ))}
      </div>
      {conAcciones && (
        <div className="flex justify-end gap-2" aria-hidden="true">
          <Skeleton height={36} width={96} />
          <Skeleton height={36} width={120} />
        </div>
      )}
    </RegionCargando>
  );
}
